import { JSX, useCallback, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

import DeleteIcon from "@mui/icons-material/Delete";

export type ImageViewProps = {
	url: string;
	loading?: boolean;
	disabled?: boolean;

	onClick?: () => void;
	onDelete?: () => void;
};

export default function ImageView(
	props: Readonly<ImageViewProps>
): JSX.Element {
	const WIDTH = 200;
	const HEIGHT = 200;

	const [url, setUrl] = useState<string>();

	useEffect(() => {
		setUrl(props.url);
	}, [props.url]);

	const showFullSize = useCallback(() => {
		props.onClick?.();
	}, []);

	function canDelete(): boolean {
		return (
			props.url !== undefined &&
			props.onDelete !== undefined &&
			props.disabled !== true &&
			props.loading !== true
		);
	}

	return (
		<Box
			sx={{
				position: "relative",
				height: HEIGHT,
				width: WIDTH
			}}>
			<img
				aria-label="image"
				style={{
					height: HEIGHT,
					width: WIDTH,
					opacity: props.loading ? 0.4 : 1,
					objectFit: "cover",
					cursor: "pointer"
				}}
				src={url}
				onClick={showFullSize}
			/>
			{canDelete() && (
				<IconButton
					sx={{
						position: "absolute",
						top: 4,
						left: 4,
						backgroundColor: "hsl(0, 100%, 100%, 50%)",
						"&:hover": {
							backgroundColor: "hsl(0, 100%, 100%, 75%)"
						}
					}}
					aria-label="delete"
					size="small"
					onClick={props.onDelete}>
					<DeleteIcon />
				</IconButton>
			)}
			{props.loading && (
				<CircularProgress
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						marginTop: "-20px",
						marginLeft: "-20px"
					}}
				/>
			)}
		</Box>
	);
}
